import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Logger } from '../logger.service';
import { CredentialsService } from './credentials.service';

/**
 * Logger declaration and initialisation.
 */
const log = new Logger('AuthenticationGuard');

/**
 * The Authentication Guard Service instance.
 */
@Injectable()
export class AuthenticationGuard {
  /**
   * The constructor instance of the Authentication Guard Service.
   *
   * @param router The injected instance of the router service.
   * @param credentialsService The injected instance of the credentials service.
   */
  constructor(private readonly router: Router, private readonly credentialsService: CredentialsService) {}

  /**
   * Can activate method.
   *
   * @param route The route identifier.
   * @param state The state identifier.
   * @returns Boolean.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.credentialsService.isAuthenticated()) {
      return true;
    }

    log.debug('Not authenticated, redirecting and adding redirect url...');
    this.router.navigate(['/login'], {
      queryParams: { redirect: state.url },
      replaceUrl: true,
    });
    return false;
  }
}
